import { v as bvVar } from 'bv';
import { t } from 'bv-i18n';

const SET = 'RIGHT_SIDEBAR.SET';
const SET_TITLE = 'RIGHT_SIDEBAR.SET_TITLE';
const HIDE = 'RIGHT_SIDEBAR.HIDE';
const SHOW = 'RIGHT_SIDEBAR.SHOW';

export const set = (component) => ({
  type: SET,
  component,
});

export const setTitle = (title) => ({
  type: SET_TITLE,
  title,
});

export const hide = () => ({
  type: HIDE,
});

export const show = () => ({
  type: SHOW,
});

const buttons = bvVar('floatingNavButtons').filter((button) => button.component);
const initialState = {
  visible: false, // Used when the right sidebar visibility is toggleable
  component: buttons[0]?.component,
  title: buttons[0]?.label,
};

const componentsData = (component) => ({
  cashout: {
    title: t('javascript.cashout.cashout'),
  },
  betslip: {
    title: t('betslip'),
  },
}[component]);

export default (state = initialState, action) => {
  switch (action.type) {
    case SET:
      return {
        ...state,
        component: action.component,
        ...componentsData(action.component),
      };
    case SET_TITLE:
      return {
        ...state,
        title: action.title,
      };
    case HIDE:
      return {
        ...state,
        visible: false,
      };
    case SHOW:
      return {
        ...state,
        visible: true,
      };
    default:
      return state;
  }
};
